// fr_pms_groups.ts
// Tłumaczenia dla PMS.Groups.tsx

export const frPmsGroups = {

  title:       "Groupes et evenements",
  description: "Apercu operationnel des reservations de groupe et des evenements lies.",
  filters:     "Filtres",
  filtersHint: "Affinez rapidement les reservations de groupe avec de nombreux evenements.",
  none:        "Aucun",

} as const;

export default frPmsGroups;
